// Pure logic for the Wants Board (ADR-0011): section/sort definitions, scope
// mapping from the browse group dropdown, query building, and the board-row →
// card-item adapter (contract in card-collection-logic.js). No side effects.

/** The three supply sections, in render order. Copy is canonical (spec). */
export const WANTS_SECTIONS = [
  { key: 'have', title: 'In your binders' },
  { key: 'network', title: 'In your network' },
  { key: 'rest', title: 'Lost, but seeking' },
];

export const WANTS_SORT_OPTIONS = [
  { value: 'most-wanted', label: 'Most wanted' },
  { value: 'price', label: 'Price' },
  { value: 'newest', label: 'Newest' },
  { value: 'name', label: 'Name' },
];

/**
 * Map the browse group dropdown to a board scope. 'all'/'mine'/absent mean
 * the whole network ('mine' has no wants-board meaning — your own supply is
 * already section 1).
 * @param {string|null|undefined} selectedGroupId
 * @param {string[]} [subgroupIds]
 */
export function scopeFromGroupId(selectedGroupId, subgroupIds = []) {
  if (!selectedGroupId || selectedGroupId === 'all' || selectedGroupId === 'mine') {
    return { scope: 'network' };
  }
  const out = { scope: 'group', groupId: selectedGroupId };
  if (subgroupIds && subgroupIds.length > 0) out.subgroupIds = subgroupIds.join(',');
  return out;
}

/**
 * Build the wants_board query string, omitting absent params.
 * @param {import('../types.js').BoardQueryParams} params
 * @returns {string}
 */
export function buildBoardQuery({ scope, groupId, subgroupIds, section, sort, cursor, q }) {
  const sp = new URLSearchParams();
  if (scope) sp.set('scope', scope);
  if (groupId) sp.set('groupId', groupId);
  if (subgroupIds) sp.set('subgroupIds', subgroupIds);
  if (section) sp.set('section', section);
  if (sort) sp.set('sort', sort);
  if (cursor) sp.set('cursor', cursor);
  if (q) sp.set('q', q);
  return sp.toString();
}

/**
 * Adapt a board row to the shared card-item contract. Wanters fill the
 * avatars column (who WANTS it — the board's subject, replacing search's
 * owners per user feedback), so holders carries `{ ownerName }` per wanter.
 * `cardName` rides alongside as the lookup key for the detail popup and the
 * row's lazy-fetched expand panel (both call `fetchBoardDetail`, which is
 * keyed by card name, not norm_name).
 * @param {Object} row - serialized row from the wants_board API
 */
export function boardRowToItem(row) {
  return {
    key: row.norm_name,
    name: row.card_name,
    set: null,
    collectorNumber: null,
    finish: null,
    rarity: row.rarity || 'common',
    typeLine: row.type_line || '',
    price: row.sample_price || 0,
    isSample: true,
    imageRef: row.sample_scryfall_id ? { scryfallId: row.sample_scryfall_id } : null,
    holders: (row.wanters || []).map((w) => ({ ownerName: w.display_name })),
    cardName: row.card_name,
  };
}
